class RelatedProducts {
  constructor(section) {
    this.section = section;
    this.init();
  }

  init() {
    // Initialize any related products functionality here
  }
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRelatedProducts);
} else {
  initRelatedProducts();
}

function initRelatedProducts() {
  const sections = document.querySelectorAll('[data-section-type="w-related-products"]');
  sections.forEach((section) => {
    new RelatedProducts(section);
  });
}

// Shopify section events
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-section-type="w-related-products"]');
    if (section) {
      new RelatedProducts(section);
    }
  });
}
